import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsIconRegistry,
} from '@cmps/ng-uikit';
import { mdiClose, mdiLoupe, mdiPencil } from '@mdi/js';

import { CmpsCommitmentSummaryGoalRowComponent } from './commitment-summary-goal-row.component';
import { CmpsCommitmentSummaryNoteRowComponent } from './commitment-summary-note-row.component';
import { CmpsCommitmentSummaryNoteDirective } from './commitment-summary-note.directive';
import { CmpsCommitmentSummaryObservationRowComponent } from './commitment-summary-observation-row.component';
import {
    CmpsCommitmentSummaryComponent,
    CmpsCommitmentSummaryGoalRowDirective,
    CmpsCommitmentSummaryNoteRowDirective,
    CmpsCommitmentSummaryObservationRowDirective,
} from './commitment-summary.component';

@NgModule({
    declarations: [
        CmpsCommitmentSummaryComponent,
        CmpsCommitmentSummaryGoalRowComponent,
        CmpsCommitmentSummaryGoalRowDirective,
        CmpsCommitmentSummaryObservationRowComponent,
        CmpsCommitmentSummaryObservationRowDirective,
        CmpsCommitmentSummaryNoteRowComponent,
        CmpsCommitmentSummaryNoteRowDirective,
        CmpsCommitmentSummaryNoteDirective,
    ],
    exports: [
        CmpsCommitmentSummaryComponent,
        CmpsCommitmentSummaryGoalRowComponent,
        CmpsCommitmentSummaryGoalRowDirective,
        CmpsCommitmentSummaryObservationRowComponent,
        CmpsCommitmentSummaryObservationRowDirective,
        CmpsCommitmentSummaryNoteRowComponent,
        CmpsCommitmentSummaryNoteRowDirective,
        CmpsCommitmentSummaryNoteDirective,
    ],
    imports: [CmpsDialogModule, CmpsIconModule, CmpsButtonModule, CommonModule],
    entryComponents: [CmpsCommitmentSummaryComponent],
})
export class CmpsCommitmentSummaryModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['pencil', mdiPencil],
            ['loupe', mdiLoupe],
            ['close', mdiClose],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
